<template>
	<div class="icon-tracker">
		<Vector
			v-for="type in availableTypes"
			:key="type.index"
			:src="insurance[type].icon.url"
			class="plan-icon"
		/>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Vector from "@/components/base/Vector";

export default {
	name: 'IconTracker',
	components: {
		Vector,
	},
	props: {
		activeType: {
			type: Number,
			required: false,
		},
	},
	computed: {
		...mapState({
			insurance: (state) => state.global.api.data.insurance,
			types: (state) => state.game.rounds.active.active_insurance_types,
		}),
		availableTypes() {
			let typesArray = [];
			if (!this.activeType) {
				typesArray = this.types;
			} else {
				typesArray.splice(0, 0, this.activeType);
			}
			return typesArray;
		},
	},
};
</script>

<style lang="scss" scoped>
	.icon-tracker {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.plan-icon {
		width: 30px;
		margin-right: 10px;

		@include tablet { width: 40px; }

		@include desktop {
			width: 40px;
			margin-right: 20px;
		}

		::v-deep .cls-1 { fill: $primary-color-extra-light; }
	}
</style>
